import React, { FunctionComponent } from 'react';
import {
  FooterWrapper,
  SocialButton,
  SocialButtonImg,
  SocialsContainer,
  StyledCopyright,
} from './Footer.styles';
import { FooterSocialLinks } from './Footer.constants';
import { useTranslation } from 'react-i18next';

export const Footer: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <FooterWrapper>
      <SocialsContainer>
        {FooterSocialLinks.map(({ link, icon }) => (
          <SocialButton key={`button-${link}`} href={t(link)} target="_blank">
            <SocialButtonImg src={icon} />
          </SocialButton>
        ))}
      </SocialsContainer>
        <StyledCopyright>{t('IP2')}</StyledCopyright>
        <StyledCopyright>&copy; {t('IP')}</StyledCopyright>
    </FooterWrapper>
  );
};
